export const APP_LIST_LIMIT = 20;
export const APP_LIST_LIMIT_OPTIONS = [20, 50, 100, 500, 1000];

export const APPLICATION_STATUS_CHIPS = [
  { value: "pending", label: "Pending" },
  { value: "contacted", label: "Contacted" },
  { value: "converted", label: "Converted" },
  { value: "rejected", label: "Rejected" },
  { value: "all", label: "All" },
];

export const KYC_LABELS = {
  0: "Not Submitted",
  1: "Pending",
  2: "Verified",
  3: "Rejected",
};

export const KYC_BADGE = {
  0: "badge--pending",
  1: "badge--pending",
  2: "badge--verified",
  3: "badge--rejected",
};

export const STATUS_BADGE = {
  pending: "badge--pending",
  contacted: "badge--contacted",
  converted: "badge--verified",
  rejected: "badge--rejected",
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

export const kycLabel = (value) => KYC_LABELS[Number(value)] || "—";

export const isKycVerified = (value) => Number(value) === 2;

export const isUnauthorized = (res) => {
  const status = Number(res?.httpStatus);
  if (status === 401) return true;
  const msg = String(res?.message || "").toLowerCase();
  return msg.includes("unauthorized") || msg.includes("jwt") || msg.includes("token is expired");
};

export const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

export const phoneHref = (countryCode, mobile) => {
  const digits = digitsOnly(`${countryCode || ""}${mobile || ""}`);
  return digits ? `tel:+${digits}` : "";
};

export const whatsappHref = (countryCode, mobile, fallbackWhatsapp) => {
  const fromField = digitsOnly(fallbackWhatsapp);
  const combined = digitsOnly(`${countryCode || ""}${mobile || ""}`);
  const digits = fromField || combined;
  return digits ? `https://wa.me/${digits}` : "";
};

export const telegramHref = (handle) => {
  const raw = String(handle || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const user = raw.replace(/^@/, "");
  return user ? `https://t.me/${user}` : "";
};

export const marketsLabel = (markets) => {
  if (!Array.isArray(markets) || !markets.length) return "—";
  return markets.join(", ");
};
